import Container from '../lib/gui/dom/Container';
import Image from '../lib/gui/dom/Image';
import Icon from '../lib/gui/dom/Icon';
import { EPGUtil } from "../Nepg/EPGUtil";
import EpgConstants from './EpgConstants';
import CodeToVal from '../../utils/CodeToVal';
import Utils from '../../utils/Utils';
import settings from '../../devices/all/settings';
import { Pin } from '../../AAF/Pin/main';
import LoadFav from '../LoaderExp/LoadFav';
import Asset from '../../requests/apa/Asset';

class ChannelController {
  constructor(channelList) {
    this.maxLenNumberChannel = 4;
    this.timerDelayChannelChange = null;
    this.codeToVal = new CodeToVal();
    this.lastNumberPressed = '';
    this.resetChannelNumberId =  null;
    this.delayChannelChange = 1500;


    this.channelList = channelList;
    this.channelsGUI = [];
    this.selectChannelUp = this.selectChannelUp.bind(this);
    this.selectChannelUpGrid = this.selectChannelUpGrid.bind(this);
    this.selectChannelDown = this.selectChannelDown.bind(this);
    this.selectChannelDownGrid = this.selectChannelDownGrid.bind(this);
    this.focusableInGrid = this.focusableInGrid.bind(this);
    this.withoutFocus = this.withoutFocus.bind(this);
    this.paintChannels = this.paintChannels.bind(this);
    this.setRedrawGridCallback = this.setRedrawGridCallback.bind(this); 
    this.setLoadingCallback = this.setLoadingCallback.bind(this);
    this.setRefChannel = this.setRefChannel.bind(this);
    this.isGridIncomplete = this.isGridIncomplete.bind(this);

    this.channelList.setEventUp(this.selectChannelUpGrid);
    this.channelList.setEventDown(this.selectChannelDownGrid);
    this.channelList.setPaintChannels(this.paintChannels);
    this.channelList.setFocus(this.focusableInGrid);
   
    

    this.redrawGridCallback = null;
    this.OpacityCallback = null;
    this.refChannel = null;
    this.channelNumberContainer = document.getElementById('channelContainerNumber') || null;
    this.imageFav = Asset.get('playingLive_program_option_button_favorites', '/images/ic_favorite.png');
    this.imageBlocked = Asset.get('playingLive_channel_option_button_lockChannel', '/images/ic_block.png');
  }

  setRefChannel(refCallback){
    this.refChannel = refCallback;
  }

  setRedrawGridCallback(callback) {
    this.redrawGridCallback = callback;
    this.channelList.setRedraw(callback);
  }

  setLoadingCallback(callback) {
    this.OpacityCallback = callback;
    this.channelList.setGridOpacity(callback);
  }


  /**
   *
   * @param {*} parentElement elemento que contiene al componente.
   * @memberof ChannelController
   */
  initialise(parentElement) {
    const offset = 3;
    const rowHeight = EpgConstants.VERTICAL_ROW_HEIGHT - offset; 
    let rowTopOffset = 0;
    let spaceBetweenRows = EpgConstants.VERTICAL_SPACE_BETWEEN_ROWS;
    this.mainContainer = new Container(parentElement, { className: 'epg-channels-container', id: 'channelListContainer' });
    for (let i = 0; i <= this.channelList.quantity - 1; i++) {
      let rowStyle = {height: rowHeight + 'px', position: 'absolute', top: rowTopOffset + 'px', left: '0px', width: '97%'};
      rowTopOffset += (spaceBetweenRows + rowHeight + offset);
      let component = new Container(null, { className: 'epg-channel-item-image-container', id: 'channelItem-' + i });
      component.setStyle(rowStyle);
      let componentNumber = new Container(null, { className: 'epg-channel-item-id', id: 'epg-channel-item-id-' + i });
      let imagecomponent = new Image(null, { className: 'epg-channel-item-image', id: 'epg-channel-item-image-id-' + i });
      let componentBlocked = new Container(null, { className: 'epg-channel-blocked-id', id: 'epg-channel-blocked-id-' + i });
      let componentFav = new Container(null, { className: 'epg-channel-fav-id', id: 'epg-channel-fav-id-' + i });

      const iconBlocked = new Image(null, { className: 'epg-channel-item-image-blocked', id: 'epg-channel-blocked-icon' + i });
      const iconFav =  new Image(null, { className: 'epg-channel-item-image-fav', id: 'epg-channel-item-image-fav-' + i });
      iconBlocked.setAttrs({ 'src': this.imageBlocked});
      iconFav.setAttrs({ 'src': this.imageFav});

      componentBlocked.addChild(iconBlocked);
      componentFav.addChild(iconFav);

      
      imagecomponent.setStyle({'display':'none'});
      componentBlocked.setStyle({'display':'none'});
      componentFav.setStyle({'display':'none'});
      
      component.addChild(componentNumber);
      component.addChild(componentBlocked);
      component.addChild(componentFav);
      component.addChild(imagecomponent);
      this.mainContainer.addChild(component);
      this.channelsGUI.push(component);
    }
  }
  /**
   *
   *
   * @param {*} channels Lista de canales a rendear.
   * @memberof ChannelController
   */
  paintChannels(channels) {
    if(channels && Array.isArray(channels) && channels.length>0){
        for (let c in this.channelsGUI) {
          this.channelsGUI[c].children.map((children) => {
            const channelInfo = channels[c];
            let isBlocked = false;
            let isFav = false;

            if(channelInfo && channelInfo.group_id && Pin.isBlockedChannelById(channelInfo.group_id)){
              isBlocked = true;
            }

            if(channelInfo && channelInfo.group_id && LoadFav.isFavorite(channelInfo.group_id)){
              isFav = true;
            }

            if (children.attrs && children.attrs.id && (typeof children.attrs.id == 'string') && children.attrs.id.indexOf('epg-channel-item-id') !== -1) {
              if(channelInfo && channelInfo.id){
                children.setText(channelInfo.id);
              }
            }
            if (children.attrs && children.attrs.id && (typeof children.attrs.id == 'string') && children.attrs.id.indexOf('epg-channel-item-image-id') !== -1) {
              if(channelInfo && channelInfo.imageEpg){
                if(children.getRootElement() && children.getRootElement().style && children.getRootElement().style.display &&  children.getRootElement().style.display =='none'){
                  children.setStyle({'display':''});
                }
                children.setAttrs({ 'src': channelInfo.imageEpg});
                if(isBlocked){
                  (typeof children.setStyle === 'function')  && children.setStyle({ opacity: EpgConstants.OPACITY_CHANNEL});
                }else{
                  (typeof children.setStyle === 'function') && children.setStyle({ opacity: EpgConstants.WITHOUT_OPACITY});
                }
              }
            }
            if (children.attrs && children.attrs.id && (typeof children.attrs.id == 'string') && children.attrs.id.indexOf('epg-channel-blocked-id') !== -1) {
              if(channelInfo && isBlocked){
                (typeof children.setStyle === 'function') && children.setStyle({'display':''});
              }else{
                (typeof children.setStyle === 'function') && children.setStyle({'display':'none'});
              }
            }
            if (children.attrs && children.attrs.id && (typeof children.attrs.id == 'string') && children.attrs.id.indexOf('epg-channel-fav-id') !== -1) {
              if(channelInfo && isFav){
                (typeof children.setStyle === 'function') && children.setStyle({'display':''});
              }else{
                (typeof children.setStyle === 'function') && children.setStyle({'display':'none'});
              }
            }
          });
      }
    }
  }


  /**
   *
   *
   * @param {string} [groupId="764168"] groupId desde donde comenzara el listado de canales.
   * @memberof ChannelController
   */
  activate(groupId = null) {
    this.channelList.setArrayInitFromGroupID(groupId);
    this.focusableInGrid(0);
  }
  /**
   *
   *
   * @memberof ChannelController Método que focusea el siguiente canal hacia arriba desde el Grid.
   */
  selectChannelDown(repeats = false) {
    this.focusable(this.channelList.downIndex(repeats));
  }


  /**
   *
   *
   * @memberof ChannelController Método que focusea el siguiente channel hacia abajo desde el Grid.
   */
  selectChannelDownGrid(repeats = false) {
    if(settings.enable_epg_pagination){
      this.focusableInGrid(this.channelList.downIndexNew(repeats));
    }else{
      this.focusableInGrid(this.channelList.downIndex(repeats));
    }
  }
  /**
   *
   *
   * @memberof ChannelController Metodo que quita el foco para modo desdespe
   */
  withoutFocus() {
    for (const x in this.channelsGUI) {
      this.channelsGUI[x].removeClassName('active');
    }
  }

  /**
   *
   *
   * @param {*} idx indice en donde se posicionara el foco en modo desdesperado.
   * @memberof ChannelController
   */
  focusable(idx) {
    for (const x in this.channelsGUI) {
      if (x == idx) {
        this.channelsGUI[x].addClassName('active');
        this.channelsGUI[x].addClassName('grid-row-select');
      } else {
        this.channelsGUI[x].removeClassName('active');
        this.channelsGUI[x].removeClassName('grid-row-select');
      }
    }
  }
  /**
   *
   *
   * @param {*} idx Indice donde seleccionar el canal desde Grilla de canales.
   * @memberof ChannelController
   */
  focusableInGrid(idx) {
    for (const x in this.channelsGUI) {
      this.channelsGUI[x].removeClassName('active');
      if (x == idx) {
        this.channelsGUI[x].addClassName('grid-row-select');
      } else {
        this.channelsGUI[x].removeClassName('grid-row-select');
      }
    }
  }
  /**
   *
   *
   * @memberof ChannelController Método que focusea y selecciona el siguiente canal
   */
  selectChannelUp(repeats = false) {
    this.focusable(this.channelList.upIndex(repeats));
  }
  selectChannelUpGrid(repeats = false) {
    if(settings.enable_epg_pagination){
      this.focusableInGrid(this.channelList.upIndexNew(repeats));
    }else{
      this.focusableInGrid(this.channelList.upIndex(repeats));
    }
    
  }


  gridOpacity(opacity){
    this.OpacityCallback(opacity);
  }


  handleChannelChange(e, number) {
    e.preventDefault();
    e.stopPropagation();
    if (this.timerDelayChannelChange) clearTimeout(this.timerDelayChannelChange);
    this.lastNumberPressed = `${this.lastNumberPressed}${number}`;
    const currentLength = this.lastNumberPressed.length;

    if ( this.channelNumberContainer && currentLength <= this.maxLenNumberChannel){ 
      this.channelNumberContainer.innerHTML = this.lastNumberPressed;
      this.channelNumberContainer.className = "epg-channel-number";
    }
    if (currentLength == this.maxLenNumberChannel) {
      this.channelChangeHandler(this.lastNumberPressed);
    } else if(currentLength < this.maxLenNumberChannel){
      this.timerDelayChannelChange = setTimeout(() => {
        this.channelChangeHandler(this.lastNumberPressed);
      }, this.delayChannelChange);
    }
  }


  channelChangeHandler(newChannel) {
    this.timerDelayChannelChange = null;
    if (this.channelNumberContainer) {
      // console.log('[JONY]-lanzandoEvento', newChannel);
      this.handleNumericChange(newChannel);
      this.channelNumberContainer.innerHTML = this.lastNumberPressed;
      this.resetChannelNumberId = setTimeout(() => {
        this.channelNumberContainer.innerHTML = '';
        this.channelNumberContainer.className = "";
        this.resetChannelNumberId = null;
        this.lastNumberPressed = '';
      }, this.delayChannelChange);
    }
  }

  handleNumericChange(newChannel){
    let allChannels =  this.channelList.getChannelList();
    if(allChannels && Array.isArray(allChannels) && allChannels.length>0){
      const channelIndex = allChannels.findIndex(channel => channel.id == newChannel);
      const channel = channelIndex >= 0 ? allChannels[channelIndex] : Utils.getClosestChannel(parseInt(newChannel), allChannels);
      if(channel && (typeof channel == 'object') && channel.group_id){
        let loadObject = {
          group_id: null,
          filter_id: null
        }

        const filter = this.channelList.getCurrentFilter();

        if(filter && (typeof filter == 'object') && filter.id){
          loadObject.filter_id = filter.id;
          loadObject.group_id = channel.group_id;
          // ACTIVANDO EL NUMERO
          this.activate(loadObject);
        }
      }
    }
  }
  
  isGridIncomplete() {
    // Funcion usada para indicar que se tiene menos canales que el total de canales a pintar.
    if(this.channelList && this.channelList.isGridIncomplete && typeof this.channelList.isGridIncomplete === 'function' ){
       return this.channelList.isGridIncomplete();
    }
    return false;
  }

  /**
   * @param {*} keyName Nombre de la tecla presionada
   * @param {*} event Evento de la tecla presionada
   * @param {*} repeats true si esta en modo desesperado
   * @returns
   * @memberof ChannelController
   */
  keyHandler(keyName, event, repeats) {
    let resp = true;

    if (keyName == 'DOWN' && repeats) {
      if(this.isGridIncomplete()) return;
      this.gridOpacity(EpgConstants.ACTIONS_LOADING.OPACITY);
      this.selectChannelDown(repeats);
    } else if (keyName == 'DOWN_UP' && !repeats) {
      // this.redrawGridCallback(this.channelList.getCurrentChannels());
    } else if (keyName == 'UP' && repeats) {
      if(this.isGridIncomplete()) return;
      this.gridOpacity(EpgConstants.ACTIONS_LOADING.OPACITY);
      this.selectChannelUp(repeats);
    } else if (keyName == 'UP_UP' && !repeats) {
      // this.redrawGridCallback(this.channelList.getCurrentChannels());
    } else if ((keyName == 'DOWN_UP' || keyName == 'UP_UP') && repeats) {
      this.withoutFocus();
      if(this.redrawGridCallback) {
        this.redrawGridCallback(this.channelList.getCurrentChannels());
      }
    }else if(keyName == 'ZERO' || keyName == 'ONE' || keyName == 'TWO' || keyName == 'THREE' || keyName == 'FOUR' || keyName == 'FIVE' || keyName == 'SIX' || keyName == 'SEVEN' || keyName == 'EIGHT' || keyName == 'NINE'){
      this.handleChannelChange(event, this.codeToVal.getKeyValue(keyName));
    }else {
      resp = false;
    }
    return resp;
  }
}


export default ChannelController;


// WEBPACK FOOTER //
// ./src/AAF/Nepg/ChannelController.js